module.exports = __webpack_public_path__ + "static/media/applenav-searchsupport.38463ae2.PNG";